"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeDate = exports.IkeDateDay = void 0;
exports.IkeDateDay = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
};
class IkeDate {
    /**
     * Get the last occurrence of the weekday to the provided day,
     * Example:
     *  Thursday near 2019-01-09 => 2019-01-03
     *
     * Usage:
     *  IkeDate.getClosestDay(new Date.UTC(2019,0,10), IkeDate.Day.Thursday) // Thursday
     *
     * @param date Date to find closest day for, Must be in UTC
     * @param weekday Weekday to get @see IkeDateDay
     */
    static getLastDay(d, weekday) {
        // Copy date so don't modify original
        const date = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
        const currentDay = date.getUTCDay();
        date.setUTCDate(date.getUTCDate() + ((weekday - currentDay - 7) % 7));
        return date;
    }
    /**
     * Get a short UTC date string in yyyy-mm-dd
     * @returns Date as a UTC yyyy-MM-dd
     **/
    static getUtcYearMonthDay(date) {
        return date.toISOString().substr(0, 10);
    }
    /**
     * Attempt to validate that a date is a real valid date
     *
     * @see https://stackoverflow.com/questions/7445328/check-if-a-string-is-a-date-value
     */
    static isValid(date) {
        const newDate = new Date(date);
        return newDate.toString() !== 'Invalid Date' && !isNaN(newDate.getTime());
    }
}
exports.IkeDate = IkeDate;
/** Common time intervals in milliseconds */
IkeDate.Interval = {
    /** One day in ms */
    Day: 24 * 60 * 60 * 1000,
    /** One hour in ms */
    Hour: 60 * 60 * 1000,
    /** One minute in ms */
    Minute: 60 * 1000,
    /** One second in ms */
    Second: 1000,
};
/** Day offset used for date functions */
IkeDate.Day = exports.IkeDateDay;
//# sourceMappingURL=date.js.map